import React from 'react'
import { Chart } from "react-google-charts";
const GoogleBarChart = ({data}) => {
  const _data = [
    ["Element", "Amount", { role: "style" }, { role: "annotation", type: "string" }],
    ["January", 303, "rgb(172, 221, 54)", ''],
    ["February", 150, "rgb(172, 221, 54)", ''],
    ["March", 482, "rgb(172, 221, 54)", ''],
    ["April", 303, "rgb(172, 221, 54)", ''],
    ["May", 150, "rgb(172, 221, 54)", ''],
    ["June", 482, "rgb(172, 221, 54)", ''],
    ["July", 303, "rgb(172, 221, 54)", ''],
    ["August", 150, "rgb(172, 221, 54)", ''],
    ["September", 482, "rgb(172, 221, 54)", ''],
    ["October", 303, "rgb(172, 221, 54)", ''],
    ["November", 150, "rgb(172, 221, 54)", ''],
    ["December", 482, "rgb(172, 221, 54)", ''],
  ];
  const options = {

    width: '100%',
    bar: { groupWidth: "50%" },
    // legend: { position: "none" },
    backgroundColor: "transparent", // Removes background color
    hAxis: { textPosition: "out" }, // Hides the y-axis labels
    chartArea: { left: 0, top: 20,right:16, width: "100%" },

  };
  return (
    <>
      <Chart
        chartType="BarChart"
        width="100%"
        height="240px"
        data={data}
        options={options}
      />
    </>
  )
}

export default GoogleBarChart
